/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import CommonLocale from "../components/LocaleLoader"
import Header from "../components/Header"
import Footer from "../components/Footer"
import TopBtn from "../components/TopBtn"
import {Helmet} from "react-helmet"
import { useLocalization } from "gatsby-theme-i18n";
import "../styles/common.scss"
import styled from '@emotion/styled';
import alertJson from '../../locales/alert.json';
import { withPrefix } from 'gatsby';
import LinkItem from "../components/LinkItem"
import { CurrentTimeProvider } from "../functions/useCurrentTime"
import { MDXProvider } from "@mdx-js/react"
import { CookiesProvider } from 'react-cookie';
import 'intersection-observer';
const shortcodes = { LinkItem }

const Layout = ({ children, location }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      
    }
  `)

  const { currentLocaleObj } = useLocalization();
  return (
    <>
      {currentLocaleObj.code === "ja" ?
        <Helmet >
          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-43364669-4" />
          <script>
            {`window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'UA-43364669-4');`}
          </script>
          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-43364669-1" />
          <script>
            {`window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', 'UA-43364669-1');`}
          </script>
        </Helmet>
      :
        <Helmet>
          <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','digitalData','GTM-P37XSWJ');`}</script>
        </Helmet>
      }
      <Helmet>
        <script>{`var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var trident = ua.indexOf('Trident/');

        if (msie > 0 || trident > 0) 
        {
          document.write('<div id="alert" class="mask" style="position:fixed;top:0;left:0;bottom:0;right:0;background:#F7F7FA;line-height:100vh;z-index:9999;text-align:center;"><div class="alert_box" style="display:inline-block;position:relative;width:928px;max-width:100%;box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);border-radius: 6px;background: #FCFCFF;padding:108px 48px 96px;color:#444448;font-size: 20px;line-height: 32px;text-align:center;margin:100px auto;vertical-align:middle;"><img style="width:104px;height:104px;display:block;margin:0 auto 44px;"src="${withPrefix('notice.jpg')}" />${alertJson[currentLocaleObj.code].browserNotSupported}</div></div>');
        }`}</script>
      </Helmet>

      <noscript>
        <div dangerouslySetInnerHTML={{__html: `<div id="alert" class="mask" style="position:fixed;top:0;left:0;bottom:0;right:0;background:#F7F7FA;line-height:100vh;z-index:9999;text-align:center;"><div class="alert_box" style="display:inline-block;position:relative;width:928px;max-width:100%;box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);border-radius: 6px;background: #FCFCFF;padding:108px 48px 96px;color:#444448;font-size: 20px;line-height: 32px;text-align:center;margin:100px auto;vertical-align:middle;"><img style="width:104px;height:104px;display:block;margin:0 auto 44px;"src="${withPrefix('notice.jpg')}" />${alertJson[currentLocaleObj.code].javascript}</div></div>`}}/>
      </noscript>
      <CommonLocale />
      <Header siteTitle={data.site.siteMetadata.title} location={location} />
      <CookiesProvider>
        <MDXProvider components={shortcodes}>
          <CurrentTimeProvider>
            <MainWrapper>
              {children}
              <TopBtn/>
            </MainWrapper>
          </CurrentTimeProvider>
        </MDXProvider>
      </CookiesProvider>
      <Footer />

      <link rel="preconnect canonical" href="https://fonts.gstatic.com" />
      {currentLocaleObj.code !== "ja" &&
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P37XSWJ"
        height="0" width="0" style={{display:'none',visibility:'hidden'}} title={'gtm'}></iframe></noscript>
      } 
      
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

const MainWrapper = styled.main`
  width:100%;
  overflow:hidden;
  position:relative;
`
